import React from "react";

// Brand-matched nav glyphs: bold rounded strokes in the violet→fuchsia brand gradient with an
// emerald accent dot, so every nav item reads as one set alongside the C.O.R.E. + S brand logos.
const VIOLET = "#6D28D9";
const FUCHSIA = "#C026D3";
const EMERALD = "#10B981";

export function BrandGlyph({ name, size = 26, active = true, className = "" }) {
  const id = `bg-${name}`;
  const g = `url(#${id})`;
  const stroke = { stroke: g, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", fill: "none" };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      style={{ opacity: active ? 1 : 0.5 }}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={id} x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor={VIOLET} />
          <stop offset="1" stopColor={FUCHSIA} />
        </linearGradient>
      </defs>
      {name === "profile" && (
        <>
          <circle cx="12" cy="8" r="4" {...stroke} />
          <path d="M5 21v-1a6 6 0 0 1 12 0v1" {...stroke} />
          <circle cx="18.5" cy="18" r="2.6" fill={EMERALD} />
        </>
      )}
      {name === "inbox" && (
        <>
          <path d="M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z" {...stroke} />
          <circle cx="12" cy="10" r="1.9" fill={EMERALD} />
        </>
      )}
      {name === "briefcase" && (
        <>
          <path d="M4 8h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Z" {...stroke} />
          <path d="M8 8V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" {...stroke} />
          <circle cx="12" cy="14" r="1.9" fill={EMERALD} />
        </>
      )}
      {name === "search" && (
        <>
          <circle cx="11" cy="11" r="7" {...stroke} />
          <path d="M20 20l-4-4" {...stroke} />
          <circle cx="11" cy="11" r="2.2" fill={EMERALD} />
        </>
      )}
      {name === "bell" && (
        <>
          <path d="M6 9a6 6 0 0 1 12 0c0 5 2.2 6.5 2.8 7H3.2C3.8 15.5 6 14 6 9Z" {...stroke} />
          <path d="M10 20a2 2 0 0 0 4 0" {...stroke} />
          <circle cx="18" cy="5.5" r="2.4" fill={EMERALD} />
        </>
      )}
    </svg>
  );
}

export default BrandGlyph;
